// extracted by mini-css-extract-plugin
export default {"container":"set-product-tabs__container___1bUNI","sets-tooltip":"set-product-tabs__sets-tooltip___1fIP0"};